export default function getFilteredFormData(values, defaults = {}) {
  const data = {
    ...defaults,
    ...values,
  };

  return Object.entries(data)
    .filter(([, value]) => value !== '' && value != null) // empty string passes `required` validation
    .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
}
